// extracted by mini-css-extract-plugin
export default {"root":"lincd_capacitor_SigninWithAppleButton_root","icon":"lincd_capacitor_SigninWithAppleButton_icon"};